import Growl from "./growl";
import CollectionProto from "../../data-structures/depricated/collection-proto";

export default class GrowlCollection extends CollectionProto<Growl>{

    constructor(models: Growl[]) {
        super(models, Growl);
    }

}


// import AmpersandCollection from 'ampersand-collection';
// import GrowlModel from './growl-model';
//
// let GrowlCollection = AmpersandCollection.extend({
//     model: GrowlModel
// });
//
// module.exports = GrowlCollection;
